import { makeStyles } from '@material-ui/core/styles'
import { getPixelInREM } from '../../common/material'

export const useReportMenuFrameStyles = makeStyles((theme) => ({
    container: {
        paddingBottom: getPixelInREM(30),
        position: 'relative'
    },
    subheaderContainer: {
        display: 'grid',
        gap: 2,
        gridAutoFlow: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: getPixelInREM(16)
    },
    title: {
        fontSize: getPixelInREM(30),
        fontWeight: 600,
        lineHeight: getPixelInREM(36),
        color: theme.palette.primary.main,
        marginTop: 0,
        marginBottom: getPixelInREM(3)
    },
    subtitle: {
        margin: 0,
        fontSize: getPixelInREM(16),
        color: theme.palette.grey[500],
        lineHeight: getPixelInREM(19)
    },
    seeListButton: {
        marginTop: getPixelInREM(5),
        display: 'block',
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        cursor: 'pointer'
    }
}))
